import { ACCEPTING_ORDER_ID, BECOME_BRAND_ID, BRAND_POLICIES_ID, CANCELING_AN_ORDER_ID, CONTACTING_MY_RETAILER_ID, CONTACT_A_BRAND_ID, DISPUTE_A_RETAILER_COMPLAINT_ID, EU_DSA_ID, FAIRE_ACCOUNT_SECURITY_ID, FAIRE_COST_ID, HOW_AM_I_NOTIFIED_NEW_ORDERS_ID, HOW_DO_NET_60_TERMS_WORK_ID, HOW_SHOULD_I_BE_SELLING_MY_FAIRE_PRODUCTS_ID, ISSUE_WITH_MY_ORDER_PAYOUT_ID, MAKE_A_RETURN_ID, NAM_SELL_ON_FAIRE_ID, NON_NAM_SELL_ON_FAIRE_ID, ORDER_INVOICE_ID, ORDER_STATUS_ID, PAYOUT_AUSTRALIAN_ID, PAYOUT_CALCULATED_ID, PAYOUT_CANADIAN_ID, PAYOUT_EUROPEAN_ID, REPORT_DAMAGED_MISSING_ID, RETAILER_WHAT_IS_FAIRE_ID, SETTING_UP_PAYOUT_ID, TAX_FORM_1099_ID, TROUBLESHOOTING_WITH_ADYEN_ID, WHERE_IS_FAIRE_AVAILABLE_ID } from "@faire/help-center-utils/articleIds";
import { Article } from "@faire/help-center-utils/articles";
import { useStrictLocalization } from "@faire/web/common/localization";
export var useArticles = function useArticles() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = {
    GettingStarted: {
      COMPLETING_ONBOARDING_FORM: new Article({
        name: strictLocalize({
          id: "C6NF6S",
          defaultMessage: "Completing my Onboarding Form"
        }),
        id: "360039212391"
      }),
      UPLOAD_FIRST_CATALOG: new Article({
        name: strictLocalize({
          id: "AlDz2c",
          defaultMessage: "Uploading your product catalog"
        }),
        id: "4416016600347"
      }),
      RESELLER_ID: new Article({
        name: strictLocalize({
          id: "POZmQR",
          defaultMessage: "Do I need a reseller ID?"
        }),
        id: "360016203651"
      }),
      BRICK_AND_MORTAR: new Article({
        name: strictLocalize({
          id: "HlhWGa",
          defaultMessage: "What if I don't have a brick & mortar?"
        }),
        id: "360016111231"
      }),
      OPEN_WITH_FAIRE: new Article({
        name: strictLocalize({
          id: "kG9smm",
          defaultMessage: "Opening with Faire"
        }),
        id: "4645924980763"
      })
    },
    MyOrders: {
      HOW_AM_I_NOTIFIED_NEW_ORDERS: new Article({
        name: strictLocalize({
          id: "DDqsse",
          defaultMessage: "How am I notified of new orders?"
        }),
        id: HOW_AM_I_NOTIFIED_NEW_ORDERS_ID
      }),
      HOW_SHOULD_I_BE_SELLING_MY_FAIRE_PRODUCT: new Article({
        name: strictLocalize({
          id: "FLONHc",
          defaultMessage: "How should I be selling my Faire products?"
        }),
        id: HOW_SHOULD_I_BE_SELLING_MY_FAIRE_PRODUCTS_ID
      }),
      BUSINESS_PROFILE: new Article({
        name: strictLocalize({
          id: "uNwAAN",
          defaultMessage: "What information is needed for my store profile?"
        }),
        id: "360035578692"
      }),
      SYNC_SQUARE_POS: new Article({
        name: strictLocalize({
          id: "CuRF0T",
          defaultMessage: "Integrating my POS System with Faire"
        }),
        id: "360037248712"
      }),
      FAIRE_PROTECTION: new Article({
        name: strictLocalize({
          id: "ymeN0d",
          defaultMessage: "What is Faire Protection?"
        }),
        id: "360016111511"
      }),
      REPORT_DAMAGED_MISSING: new Article({
        name: strictLocalize({
          id: "v9kPYq",
          defaultMessage: "How do I report damaged or missing items?"
        }),
        id: REPORT_DAMAGED_MISSING_ID
      }),
      ORDER_STATUS: new Article({
        name: strictLocalize({
          id: "t0xr1I",
          defaultMessage: "When will I get my orders?"
        }),
        id: ORDER_STATUS_ID
      }),
      ORDER_RETURNED_TO_SENDER: new Article({
        name: strictLocalize({
          id: "9S0FTQ",
          defaultMessage: "Order returned to sender"
        }),
        id: "26594585812891"
      }),
      ORDER_QUESTIONS: new Article({
        name: strictLocalize({
          id: "9LqEo1",
          defaultMessage: "Questions about an item"
        }),
        id: "360006953111"
      }),
      BRAND_MINIMUMS: new Article({
        name: strictLocalize({
          id: "w5vD/I",
          defaultMessage: "What are order minimums"
        }),
        id: "360016302912"
      }),
      CANCELING_AN_ORDER: new Article({
        name: strictLocalize({
          id: "0VnS38",
          defaultMessage: "How can I cancel an order?"
        }),
        id: CANCELING_AN_ORDER_ID
      }),
      CONTACT_A_BRAND: new Article({
        name: strictLocalize({
          id: "SjOF+W",
          defaultMessage: "How do I contact a brand on Faire?"
        }),
        id: CONTACT_A_BRAND_ID
      })
    },
    ManageMyShop: {
      ADD_EDIT_PRODUCTS: new Article({
        name: strictLocalize({
          id: "9Rgpw6",
          defaultMessage: "How do I add or edit products?"
        }),
        id: "360006829831"
      }),
      BRAND_PROMOTION_CALCULATED: new Article({
        name: strictLocalize({
          id: "/rgb2v",
          defaultMessage: "How are promotions calculated?"
        }),
        id: "360032489472"
      }),
      CUSTOMIZE_MY_PRODUCT_TRANSLATIONS: new Article({
        name: strictLocalize({
          id: "5p35uh",
          defaultMessage: "Can I customize my product translations?"
        }),
        id: "7652446722331"
      }),
      CURRENCY_SPECIFIC_PRICING: new Article({
        name: strictLocalize({
          id: "W+2iJv",
          defaultMessage: "Currency specific pricing"
        }),
        id: "360055558732"
      }),
      SETTING_PRODUCT_INVENTORY_LEVELS: new Article({
        name: strictLocalize({
          id: "2saxOG",
          defaultMessage: "Setting my product inventory levels"
        }),
        id: "360045187791"
      }),
      ARRANGE_MY_SHOP_LISTINGS: new Article({
        name: strictLocalize({
          id: "kspgKw",
          defaultMessage: "How do I arrange my shop listings?"
        }),
        id: "360039477271"
      }),
      WHAT_IS_EXCLUSIVITY_PROGRAM: new Article({
        name: strictLocalize({
          id: "Ddnv4m",
          defaultMessage: "What is the exclusivity program?"
        }),
        id: "18543447335451"
      })
    },
    Referrals: {
      CAN_I_REFER_BRANDS_TO_FAIRE: new Article({
        name: strictLocalize({
          id: "TG9PtX",
          defaultMessage: "Can I refer brands to Faire?"
        }),
        id: "4404937922587"
      }),
      USE_REFERRAL_PROMOTION: new Article({
        name: strictLocalize({
          id: "FJ+m6x",
          defaultMessage: "How can I use a referral promotion from a brand?"
        }),
        id: "360034300092"
      })
    },
    OptimizingMyPage: {
      COVER_IMAGE_GUIDELINES: new Article({
        name: strictLocalize({
          id: "fXnXFB",
          defaultMessage: "Cover image guidelines"
        }),
        id: "360016791851"
      }),
      PRODUCT_PHOTOGRAPHY_GUIDELINES: new Article({
        name: strictLocalize({
          id: "YINiMH",
          defaultMessage: "Product Photography Guidelines"
        }),
        id: "360016568092"
      }),
      IMAGE_SIZE_REQUIREMENTS: new Article({
        name: strictLocalize({
          id: "lXeU3d",
          defaultMessage: "Image size requirements"
        }),
        id: "360032130371"
      }),
      BRAND_STORY_GUIDELINES: new Article({
        name: strictLocalize({
          id: "d3h1Ep",
          defaultMessage: "Brand story guidelines"
        }),
        id: "360026756912"
      }),
      ADD_VIDEO: new Article({
        name: strictLocalize({
          id: "LJd4Gb",
          defaultMessage: "Can I add a video to my shop?"
        }),
        id: "360054846452"
      })
    },
    InvoicesAndBilling: {
      RECEIVE_ORDER_INVOICE: new Article({
        name: strictLocalize({
          id: "X9dXUE",
          defaultMessage: "Will I receive an order invoice?"
        }),
        id: "4408351766171"
      }),
      PRODUCT_REPORT: new Article({
        name: strictLocalize({
          id: "DE+DLf",
          defaultMessage: "What if a retailer reports my products missing or damaged?"
        }),
        id: "360033568051"
      }),
      PAYOUT_CALCULATED: new Article({
        name: strictLocalize({
          id: "eE3x7A",
          defaultMessage: "How is my payout calculated?"
        }),
        id: PAYOUT_CALCULATED_ID
      }),
      PAYOUT_EUROPEAN: new Article({
        name: strictLocalize({
          id: "OiNzBj",
          defaultMessage: "How do I set up payouts to a European bank account?"
        }),
        id: PAYOUT_EUROPEAN_ID
      }),
      PAYOUT_AUSTRALIAN: new Article({
        name: strictLocalize({
          id: "NsyCP6",
          defaultMessage: "How do I set up payouts to an Australian bank account?"
        }),
        id: PAYOUT_AUSTRALIAN_ID
      }),
      PAYOUT_CANADIAN: new Article({
        name: strictLocalize({
          id: "M1uK1z",
          defaultMessage: "Payouts for Canadian brands"
        }),
        id: PAYOUT_CANADIAN_ID
      }),
      ISSUE_WITH_MY_ORDER_PAYOUT: new Article({
        name: strictLocalize({
          id: "GeTSEg",
          defaultMessage: "Issue with my order payout"
        }),
        id: ISSUE_WITH_MY_ORDER_PAYOUT_ID
      }),
      TAX_FORM_1099: new Article({
        name: strictLocalize({
          id: "P/vdrr",
          defaultMessage: "Will I Receive a 1099-K Tax Form?"
        }),
        id: TAX_FORM_1099_ID
      }),
      SETTING_UP_PAYOUT: new Article({
        name: strictLocalize({
          id: "qkrW6t",
          defaultMessage: "Setting up your payout account"
        }),
        id: SETTING_UP_PAYOUT_ID
      }),
      TROUBLESHOOTING_WITH_ADYEN: new Article({
        name: strictLocalize({
          id: "ipXayn",
          defaultMessage: "​​Troubleshooting with Adyen"
        }),
        id: TROUBLESHOOTING_WITH_ADYEN_ID
      }),
      PAYOUT_ISSUE: new Article({
        name: strictLocalize({
          id: "GeTSEg",
          defaultMessage: "Issue with my order payout"
        }),
        id: "360006915532"
      }),
      TAX_INFORMATION: new Article({
        name: strictLocalize({
          id: "/xy/gD",
          defaultMessage: "Setting up tax information"
        }),
        id: "360038950092"
      }),
      NAM_SELL_ON_FAIRE: new Article({
        name: strictLocalize({
          id: "ztJJ3l",
          defaultMessage: "How much does it cost to sell on Faire if I’m based in North America?"
        }),
        id: NAM_SELL_ON_FAIRE_ID
      }),
      NON_NAM_SELL_ON_FAIRE: new Article({
        name: strictLocalize({
          id: "0wp1lr",
          defaultMessage: "How much does it cost to sell on Faire if I’m based outside of North America?"
        }),
        id: NON_NAM_SELL_ON_FAIRE_ID
      })
    },
    Account: {
      ORDER_ISSUE: new Article({
        name: strictLocalize({
          id: "CuhRSF",
          defaultMessage: "Why can’t I see my retailer’s order in my account?"
        }),
        id: "4415920212123"
      }),
      CANNOT_FIND_ORDER_NUMBER: new Article({
        name: strictLocalize({
          id: "BBAJ+h",
          defaultMessage: "Why can’t I find a retailer’s order number?"
        }),
        id: "4402385627163"
      }),
      NOT_OPEN: new Article({
        name: strictLocalize({
          id: "nWFeyz",
          defaultMessage: "We aren’t open yet. Can I still order?"
        }),
        id: "360016111571"
      }),
      ACCOUNT_EMAIL: new Article({
        name: strictLocalize({
          id: "yV7GVR",
          defaultMessage: "Changing my login email"
        }),
        id: "360016302272"
      }),
      MANAGE_TEAMS: new Article({
        name: strictLocalize({
          id: "Z1h57J",
          defaultMessage: "Set up your team on Faire"
        }),
        id: "8675579278619"
      }),
      EMAIL_NOTIFICATIONS: new Article({
        name: strictLocalize({
          id: "Xbq6xK",
          defaultMessage: "Can I unsubscribe from specific Faire emails?"
        }),
        id: "360059197351"
      }),
      EMAIL_PREFERENCES: new Article({
        name: strictLocalize({
          id: "o547a2",
          defaultMessage: "Setting my Email Preferences"
        }),
        id: "360057278792"
      }),
      RESETTING_PASSWORD: new Article({
        name: strictLocalize({
          id: "3o8L8n",
          defaultMessage: "Resetting my password"
        }),
        id: "360019610312"
      }),
      WHAT_IS_EXCLUSIVITY: new Article({
        name: strictLocalize({
          id: "x+S067",
          defaultMessage: "What is exclusivity?"
        }),
        id: "19903209185947"
      })
    },
    FaireDirect: {
      ORDER_COMMISSION: new Article({
        name: strictLocalize({
          id: "s4fd/u",
          defaultMessage: "My Direct order has commission, what happened?"
        }),
        id: "360031800672"
      }),
      ZERO_COMMISSION: new Article({
        name: strictLocalize({
          id: "GTHgGi",
          defaultMessage: "Faire Direct Policy for 0% Commission"
        }),
        id: "360031800672"
      }),
      EMAIL_CAMPAIGN: new Article({
        name: strictLocalize({
          id: "4SUKRT",
          defaultMessage: "What is an Email Campaign?"
        }),
        id: "360038731612"
      }),
      EMAIL_AUTOMATIONS: new Article({
        name: strictLocalize({
          id: "YvFUHb",
          defaultMessage: "What are Email Automations?"
        }),
        id: "360034668751"
      }),
      FAIRE_DIRECT: new Article({
        name: strictLocalize({
          id: "zTqoXs",
          defaultMessage: "What is Faire Direct?"
        }),
        id: "360032132391"
      }),
      FD_ELIGIBLE: new Article({
        name: strictLocalize({
          id: "zbXaBM",
          defaultMessage: "Who is eligible to order via Faire Direct?"
        }),
        id: "360032149291"
      }),
      FD_LINK: new Article({
        name: "How do I use my Direct Link?",
        id: "360032133351"
      }),
      WIDGET_GENERAL: new Article({
        name: strictLocalize({
          id: "DHXK5c",
          defaultMessage: "What is the Faire Direct widget?"
        }),
        id: "360040031351"
      }),
      WIDGET_SHOPIFY: new Article({
        name: strictLocalize({
          id: "EqLkX6",
          defaultMessage: "How to embed your Faire Direct widget on Shopify"
        }),
        id: "10268063927579"
      }),
      WIDGET_WOOCOMMERCE: new Article({
        name: strictLocalize({
          id: "gopKdg",
          defaultMessage: "How to embed your Faire Direct widget on WooCommerce"
        }),
        id: "24153780884763"
      }),
      WIDGET_PRESTASHOP: new Article({
        name: strictLocalize({
          id: "1FFXmi",
          defaultMessage: "How to embed your Faire Direct widget on Prestashop"
        }),
        id: "25144215925787"
      })
    },
    FulfillingOrders: {
      SPLIT_ATS_ORDER: new Article({
        name: strictLocalize({
          id: "7DQaFp",
          defaultMessage: "How to split an ATS order"
        }),
        id: "360060488431"
      }),
      SPLIT_PREORDER: new Article({
        name: strictLocalize({
          id: "5Pei21",
          defaultMessage: "How to split a preorder"
        }),
        id: "360060414111"
      }),
      ACCEPTING_ORDER: new Article({
        name: strictLocalize({
          id: "osVMG8",
          defaultMessage: "Accepting an order"
        }),
        id: ACCEPTING_ORDER_ID
      }),
      COMMERCIAL_INVOICE: new Article({
        name: strictLocalize({
          id: "WCJyt7",
          defaultMessage: "How do I create a commercial invoice"
        }),
        id: "4404314652059"
      }),
      FULFILLING_ORDER: new Article({
        name: strictLocalize({
          id: "hE2Nbm",
          defaultMessage: "I can't fulfill an order"
        }),
        id: "360007184831"
      }),
      UNDERSTAND_ORDER_STATUS: new Article({
        name: strictLocalize({
          id: "5R1ZVj",
          defaultMessage: "Understanding your order's status"
        }),
        id: ORDER_INVOICE_ID
      }),
      CAN_RETAILER_CANCEL_ORDER: new Article({
        name: strictLocalize({
          id: "0UcJaN",
          defaultMessage: "Can a retailer cancel their order?"
        }),
        id: "360023102031"
      }),
      SHIPPING_ORDER: new Article({
        name: strictLocalize({
          id: "LTM3/z",
          defaultMessage: "Shipping an order"
        }),
        id: "360023300451"
      }),
      SETTING_OUT_OF_STOCK: new Article({
        name: strictLocalize({
          id: "kEJsXY",
          defaultMessage: "Setting out-of-stock or discontinued items"
        }),
        id: "360006911352"
      }),
      SHIP_WITH_FAIRE: new Article({
        name: strictLocalize({
          id: "72y5ni",
          defaultMessage: "Ship with Faire"
        }),
        id: "360030933131"
      }),
      LABEL_ISSUES: new Article({
        name: strictLocalize({
          id: "oBNgYb",
          defaultMessage: "Why am I getting an error when using Ship with Faire"
        }),
        id: "360040920571"
      }),
      SHIP_ON_YOUR_OWN: new Article({
        name: strictLocalize({
          id: "IlfctE",
          defaultMessage: "How to ship orders on your own"
        }),
        id: "360030933311"
      }),
      SHIPPING_COSTS: new Article({
        name: strictLocalize({
          id: "SPzcuL",
          defaultMessage: "Managing shipping costs to other countries"
        }),
        id: "360040349352"
      }),
      SHIPPING_WORK: new Article({
        name: strictLocalize({
          id: "ybSoRd",
          defaultMessage: "How does shipping work?"
        }),
        id: "4405859125531"
      }),
      ABOUT_SHIPPING: new Article({
        name: strictLocalize({
          id: "1JAZ0s",
          defaultMessage: "What about shipping?"
        }),
        id: "360016111831"
      }),
      SHIPPING_ADDRESS: new Article({
        name: strictLocalize({
          id: "NAicKW",
          defaultMessage: "How do I change my shipping address"
        }),
        id: "360018235292"
      }),
      CHANGE_SHIPPING_ADDRESS: new Article({
        name: strictLocalize({
          id: "v3+vuS",
          defaultMessage: "Can I change my address after order shipped?"
        }),
        id: "360007197951"
      }),
      EDIT_RETAILER_ORDER: new Article({
        name: strictLocalize({
          id: "ArjSpz",
          defaultMessage: "Can I edit a retailer’s order"
        }),
        id: "360053212551"
      })
    },
    ReturnsAndRefunds: {
      MAKE_A_RETURN: new Article({
        name: strictLocalize({
          id: "PTuRfO",
          defaultMessage: "How do I submit a return?"
        }),
        id: MAKE_A_RETURN_ID
      }),
      EXTEND_A_RETURN: new Article({
        name: strictLocalize({
          id: "hDezWS",
          defaultMessage: "Can I extend my return window?"
        }),
        id: "360022876131"
      }),
      CANT_RETURN: new Article({
        name: strictLocalize({
          id: "F85fJa",
          defaultMessage: "Why can’t I return my items?"
        }),
        id: "360007069352"
      })
    },
    PaymentsAndInvoices: {
      CHANGE_MY_PAYMENT_METHOD: new Article({
        name: strictLocalize({
          id: "sRWcLE",
          defaultMessage: "Changing my payment method"
        }),
        id: "360018497831"
      }),
      NET_60_TERMS: new Article({
        name: strictLocalize({
          id: "17QDXy",
          defaultMessage: "How do net 60 terms work?"
        }),
        id: HOW_DO_NET_60_TERMS_WORK_ID
      }),
      PAY_INVOICES: new Article({
        name: strictLocalize({
          id: "+8Ngr8",
          defaultMessage: "How do I pay my invoices?"
        }),
        id: "360006920172"
      }),
      INVOICE_DUE: new Article({
        name: strictLocalize({
          id: "r9dmpJ",
          defaultMessage: "When is my invoice due?"
        }),
        id: "360006994232"
      }),
      UNDERSTANDING_ORDER_INVOICE: new Article({
        name: strictLocalize({
          id: "COn3iE",
          defaultMessage: "Understanding the order Invoice"
        }),
        id: "4416125712795"
      }),
      HOW_DO_I_PAY_FOR_ORDERS: new Article({
        name: strictLocalize({
          id: "1k8YBm",
          defaultMessage: "How do I pay for orders?"
        }),
        id: "360015892632"
      }),
      HOW_DO_I_CHANGE_MY_BILLING_ADDRESS: new Article({
        name: strictLocalize({
          id: "jdoE1a",
          defaultMessage: "How do I change my billing address?"
        }),
        id: "24430827309467"
      })
    },
    INSIDER: {
      INSIDER_BRAND_PARTNERSHIP: new Article({
        name: strictLocalize({
          id: "H8tXRk",
          defaultMessage: "The Insider Partnership for brands"
        }),
        id: "25213101060123"
      })
    },
    FAQ: {
      RESETTING_PASSWORD: new Article({
        name: strictLocalize({
          id: "3o8L8n",
          defaultMessage: "Resetting my password"
        }),
        id: "360019854651"
      }),
      RETAILER_WHAT_IS_FAIRE: new Article({
        name: strictLocalize({
          id: "lDcCOD",
          defaultMessage: "How do I start buying on Faire?"
        }),
        id: RETAILER_WHAT_IS_FAIRE_ID
      }),
      EU_DSA: new Article({
        name: strictLocalize({
          id: "bdi6Mi",
          defaultMessage: "EU Digital Services Act Single Point of Contact"
        }),
        id: EU_DSA_ID
      }),
      HOW_RETURNS_WORK: new Article({
        name: strictLocalize({
          id: "3+R7cy",
          defaultMessage: "How do returns work"
        }),
        id: "360015892592"
      }),
      FAIRE_INSIDER_US: new Article({
        name: strictLocalize({
          id: "zPGP9w",
          defaultMessage: "How does Insider for US retailers work?"
        }),
        id: "4406840862747"
      }),
      FAIRE_INSIDER_EU: new Article({
        name: strictLocalize({
          id: "Ua9ksa",
          defaultMessage: "How does Insider work for European retailers?"
        }),
        id: "4418050425115"
      }),
      WHERE_IS_FAIRE_AVAILABLE: new Article({
        name: strictLocalize({
          id: "m68Icb",
          defaultMessage: "Where is Faire available?"
        }),
        id: WHERE_IS_FAIRE_AVAILABLE_ID
      }),
      BRAND_REFERRAL_PROGRAM_TERMS_CONDITIONS: new Article({
        name: strictLocalize({
          id: "rAW53+",
          defaultMessage: "FAIRE BRAND REFERRAL PROGRAM TERMS & CONDITIONS"
        }),
        id: "13628687993371"
      }),
      FAIRE_ACCOUNT_SECURITY: new Article({
        name: strictLocalize({
          id: "evS1O1",
          defaultMessage: "Faire account security best practices"
        }),
        id: FAIRE_ACCOUNT_SECURITY_ID
      })
    },
    FAQForProspectiveBrands: {
      HOW_GET_PAID: new Article({
        name: strictLocalize({
          id: "LYRxSA",
          defaultMessage: "How do I get paid?"
        }),
        id: "360015893272"
      }),
      FAIRE_COST: new Article({
        name: strictLocalize({
          id: "36qrix",
          defaultMessage: "How much does it cost to sell on Faire?"
        }),
        id: FAIRE_COST_ID
      }),
      BECOME_BRAND: new Article({
        name: strictLocalize({
          id: "ICLZE5",
          defaultMessage: "How do I sell on Faire?"
        }),
        id: BECOME_BRAND_ID
      })
    },
    International: {
      VAT_WORK_NON_EU_ORDERS: new Article({
        name: strictLocalize({
          id: "XXZP7G",
          defaultMessage: "How does VAT work for Non-E.U. European orders?"
        }),
        id: "4404431808155"
      }),
      PAY_VAT_NON_EU: new Article({
        name: strictLocalize({
          id: "MIkkag",
          defaultMessage: "How will I pay VAT on my orders in Non-EU European countries?"
        }),
        id: "4404431878683"
      }),
      VAT_WORK_EU_ORDERS: new Article({
        name: strictLocalize({
          id: "ox+alG",
          defaultMessage: "How does VAT work for E.U. orders?"
        }),
        id: "360057747911"
      }),
      CANADIAN_RETAILERS: new Article({
        name: strictLocalize({
          id: "2l9kFh",
          defaultMessage: "Getting started as a Canadian retailer"
        }),
        id: "360034894292"
      }),
      LOCATION_SHOP_LIVE: new Article({
        name: strictLocalize({
          id: "/BK1wq",
          defaultMessage: "Can I control the locations where my shop is live?"
        }),
        id: "360016524391"
      }),
      SELLING: new Article({
        name: strictLocalize({
          id: "vR2146",
          defaultMessage: "A guide to selling internationally on Faire"
        }),
        id: "4407511671579"
      }),
      BUY: new Article({
        name: strictLocalize({
          id: "MAingx",
          defaultMessage: "How to buy internationally on Faire"
        }),
        id: "4405345083675"
      })
    },
    ContactMyRetailer: {
      CONTACTING_MY_RETAILER: new Article({
        name: strictLocalize({
          id: "53rQbV",
          defaultMessage: "How do I contact my retailers on Faire?"
        }),
        id: CONTACTING_MY_RETAILER_ID
      })
    },
    BrandTermsAndPolicies: {
      DISPUTE_A_RETAILER_COMPLAINT: new Article({
        name: strictLocalize({
          id: "vFNhSP",
          defaultMessage: "Dispute a retailer complaint"
        }),
        id: DISPUTE_A_RETAILER_COMPLAINT_ID
      }),
      BRAND_POLICIES: new Article({
        name: strictLocalize({
          id: "lLVQEM",
          defaultMessage: "Brand policies"
        }),
        id: BRAND_POLICIES_ID
      })
    },
    ImportFeesAndDuties: {
      DUTIES_REFUND: new Article({
        name: strictLocalize({
          id: "cgQGPC",
          defaultMessage: "What happens when Faire covers my import duties?"
        }),
        id: "4403349101723"
      }),
      USA: new Article({
        name: strictLocalize({
          id: "lc7vKv",
          defaultMessage: "How does shipping into the US work?"
        }),
        id: "360031133351"
      }),
      Canada: new Article({
        name: strictLocalize({
          id: "zsTBx4",
          defaultMessage: "How does shipping into Canada work?"
        }),
        id: "360057607832"
      }),
      Europe: new Article({
        name: strictLocalize({
          id: "XLscSH",
          defaultMessage: "Importing to Europe"
        }),
        id: "360056061932"
      }),
      Australia: new Article({
        name: strictLocalize({
          id: "PXuWXh",
          defaultMessage: "Importing to Australia"
        }),
        id: "6668590967579"
      }),
      EORI: new Article({
        name: strictLocalize({
          id: "93QqWi",
          defaultMessage: "How do I apply for an EORI number?"
        }),
        id: "4409464460187"
      }),
      VAT: new Article({
        name: strictLocalize({
          id: "KVID5a",
          defaultMessage: "Do I need a VAT number?"
        }),
        id: "4405333889435"
      })
    },
    Integration: {
      SOFTWARE_INTEGRATION_WITH_FAIRE: new Article({
        name: strictLocalize({
          id: "M/W49R",
          defaultMessage: "Software integration with Faire"
        }),
        id: "360037964391"
      }),
      ONBOARDING_WITH_SHOPIFY: new Article({
        name: strictLocalize({
          id: "SDYcWM",
          defaultMessage: "Onboarding with Shopify"
        }),
        id: "4407533398939"
      }),
      CAN_I_INTEGRATE_WITH_SHOPIFY: new Article({
        name: strictLocalize({
          id: "rkM/49",
          defaultMessage: "Can I integrate with Shopify?"
        }),
        id: "360054245292"
      })
    }
  };
  return articles;
};